// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { Checkbox } from 'primereact/checkbox';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';

// Multi lang
import { withTranslation } from 'react-multi-lang';
// Styling
import './allowance-meal-hotel-travel-detail.scss';
import { getPrettyDatetime } from '../../../../common/utils/date-utils';
import { ALLOWANCE_APPROVED, ALLOWANCE_NOT_APPROVED } from '../../../../common/constants';

class AllowanceMealHotelTravelComponent extends Component {

  render() {

    return (
                this.props.allowanceTravelMealHotel !== null ?
                    <>
                        <div className="col-12 mgt-10">
                            <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.need")}</b></label>
                        </div>
                        <div className="col-12">
                            <div key={1} className="flex">
                                <RadioButton disabled inputId="travel-type-1" className='mgt-5' name="travelType1" checked={this.props.allowanceTravelMealHotel.payment} />
                                <label htmlFor="travel-type-1" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.travel-type-1")}</label>
                            </div>
                            <div key={2} className="flex">
                                <RadioButton disabled inputId="travel-type-2" className='mgt-5' name="travelType2" checked={this.props.allowanceTravelMealHotel.returnExpenses} />
                                <label htmlFor="travel-type-2" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.travel-type-2")}</label>
                            </div>
                        </div>
                        {
                            this.props.allowanceTravelMealHotel.paymentExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.paymentExpenseDecision !== null ?
                                <div className="col-12 lg:col-12">
                                    <div className="flex flex-column gap-2">
                                        {
                                            this.props.state === ALLOWANCE_APPROVED ?
                                                <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.paymentExpenseDecision}</label>
                                                :
                                                null 
                                        }
                                        {
                                            this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.paymentExpenseDecision}</label>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                                : null
                        }
                        {
                            this.props.allowanceTravelMealHotel.hotel || this.props.allowanceTravelMealHotel.meal ?
                                <>
                                    <div className="col-12 mgt-10">
                                        <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.type-meal-hotel")}</b></label>
                                    </div>
                                    <div className="col-12 lg:col-3">
                                        <Checkbox disabled inputId="cb-hotel" checked={this.props.allowanceTravelMealHotel.hotel}></Checkbox>
                                        <label htmlFor="hasHotel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.hotel")}</label>
                                    </div>
                                    <div className="col-12 lg:col-9"></div>
                                    {
                                        this.props.allowanceTravelMealHotel.hotel ?
                                        <>
                                            <div className="col-12 lg:col-4">
                                                <div className="flex flex-column gap-2">
                                                    <label className='mgr-10' htmlFor="hotel-name">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-name")}</label>
                                                    <InputText disabled maxLength={50} value={this.props.allowanceTravelMealHotel.hotelName} id="bus-start" type="text" />
                                                </div>
                                            </div>
                                            <div className="col-12 lg:col-2">
                                                <div className="flex flex-column gap-2">
                                                    <label className='mgr-10' htmlFor="hotel-stars">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-stars")}</label>
                                                    <InputText disabled maxLength={1} pattern="\d*" value={this.props.allowanceTravelMealHotel.numStars} id="hotel-stars" type="text" />
                                                </div>
                                            </div>
                                            <div className="col-12 lg:col-2">
                                                <div className="flex flex-column gap-2">
                                                    <label className='mgr-10' htmlFor="hotel-price">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-price")}</label>
                                                    <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.dailyPrice} id="hotel-price" type="text" />
                                                </div>
                                            </div>
                                            <div className="col-12 lg:col-4">
                                                <div className="flex flex-column gap-2">
                                                    <label className='mgr-10' htmlFor="hotel-phone">{this.props.t("allowances.dialog.travel-hotel-meal.hotel-phone")}</label>
                                                    <InputText disabled maxLength={15} pattern="\d*" value={this.props.allowanceTravelMealHotel.telephoneNumber} id="hotel-phone" type="text" />
                                                </div>
                                            </div>
                                            {
                                                this.props.allowanceTravelMealHotel.hotelExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.hotelExpenseDecision !== null ?
                                                    <div className="col-12 lg:col-12">
                                                        <div className="flex flex-column gap-2">
                                                            {
                                                                this.props.state === ALLOWANCE_APPROVED ?
                                                                    <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.hotelExpenseDecision}</label>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                                    <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.hotelExpenseDecision}</label>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                        </>
                                        : null
                                    }
                                    <div className="col-12 lg:col-4">
                                        <Checkbox disabled inputId="cb-meal" checked={this.props.allowanceTravelMealHotel.meal}></Checkbox>
                                        <label htmlFor="has-meal" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.meal")}</label>
                                    </div>
                                    {
                                        this.props.allowanceTravelMealHotel.meal ?
                                            <div className="col-12 lg:col-2">
                                                <div className="flex flex-column gap-2">
                                                    <label htmlFor="meal-number" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.meal-number")}</label>
                                                    <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.mealNumber} id="meal-number" type="text" />
                                                </div>
                                            </div>
                                            : null  
                                    }
                                    {
                                        this.props.allowanceTravelMealHotel.mealExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.mealExpenseDecision !== null ?
                                            <div className="col-12 lg:col-12">
                                                <div className="flex flex-column gap-2">
                                                    {
                                                        this.props.state === ALLOWANCE_APPROVED ?
                                                            <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.mealExpenseDecision}</label>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                            <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.mealExpenseDecision}</label>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            : null
                                    }
                                </>
                                : null
                        }
                        <div className="col-12 mgt-10">
                            <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.type-travel")}</b></label>
                        </div>
                        <div className="col-12 lg:col-6">
                            <div className="flex flex-column gap-2">
                                <label className='mgr-10' htmlFor="start-period-date">{this.props.t("allowances.dialog.travel-hotel-meal.start-period")}</label>
                                <InputText disabled value={getPrettyDatetime(this.props.allowanceTravelMealHotel.beginDate)} id="start-period-date" type="text" />
                            </div>
                        </div>
                        <div className="col-12 lg:col-6">
                            <div className="flex flex-column gap-2">
                                <label className='mgr-10' htmlFor="return-period-date">{this.props.t("allowances.dialog.travel-hotel-meal.return-period")}</label>
                                <InputText disabled value={getPrettyDatetime(this.props.allowanceTravelMealHotel.endDate)} id="return-period-date" type="text" />
                            </div>
                        </div>
                        <div className="col-12">
                            <Checkbox disabled inputId="cb-bus-travel" checked={this.props.allowanceTravelMealHotel.bus}></Checkbox>
                            <label htmlFor="busTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.bus")}</label>
                        </div>
                        {
                            this.props.allowanceTravelMealHotel.bus ?
                            <>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.busPrice} id="bus-start" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.busReturnPrice} id="bus-end" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-6"></div>
                                {
                                    this.props.allowanceTravelMealHotel.busExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.busExpenseDecision !== null ?
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                {
                                                    this.props.state === ALLOWANCE_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.busExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.busExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                            : 
                            null
                        }
                        <div className="col-12">
                            <Checkbox disabled inputId="cb-train-travel" checked={this.props.allowanceTravelMealHotel.train}></Checkbox>
                            <label htmlFor="trainTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.train")}</label>
                        </div>
                        {
                            this.props.allowanceTravelMealHotel.train ?
                            <>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.trainPrice} id="bus-start" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.trainReturnPrice} id="bus-end" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-6"></div>
                                {
                                    this.props.allowanceTravelMealHotel.trainExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.trainExpenseDecision !== null ?
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                {
                                                    this.props.state === ALLOWANCE_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.trainExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.trainExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                            : 
                            null
                        }
                        <div className="col-12">
                            <Checkbox disabled inputId="cb-car-travel" checked={this.props.allowanceTravelMealHotel.car}></Checkbox>
                            <label htmlFor="carTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.car")}</label>
                        </div>
                        {
                            this.props.allowanceTravelMealHotel.car ?
                            <>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="car-plate">{this.props.t("allowances.dialog.travel-hotel-meal.car-plate")}</label>
                                        <InputText disabled maxLength={10} value={this.props.allowanceTravelMealHotel.carPlate} id="car-plate" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="car-km">{this.props.t("allowances.dialog.travel-hotel-meal.car-km")}</label>
                                        <InputText disabled maxLength={3} pattern="\d*" value={this.props.allowanceTravelMealHotel.carKms} id="car-km" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-6"></div>
                                {
                                    this.props.allowanceTravelMealHotel.carExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.carExpenseDecision !== null ?
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                {
                                                    this.props.state === ALLOWANCE_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.carExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.carExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                            : 
                            null
                        }
                        <div className="col-12">
                            <Checkbox disabled inputId="cb-taxi-travel" checked={this.props.allowanceTravelMealHotel.taxi}></Checkbox>
                            <label htmlFor="taxiTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.taxi")}</label>
                        </div>
                        {
                            this.props.allowanceTravelMealHotel.taxi ?
                            <>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.taxiPrice} id="bus-start" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.taxiReturnPrice} id="bus-end" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-6"></div>
                                {
                                    this.props.allowanceTravelMealHotel.taxiExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.taxiExpenseDecision !== null ?
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                {
                                                    this.props.state === ALLOWANCE_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.taxiExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.taxiExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                            : 
                            null
                        }
                        <div className="col-12">
                            <Checkbox disabled inputId="cb-plane-travel" checked={this.props.allowanceTravelMealHotel.plane}></Checkbox>
                            <label htmlFor="planeTravel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.travel-hotel-meal.plane")}</label>
                        </div>
                        {
                            this.props.allowanceTravelMealHotel.plane ?
                            <>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-start">{this.props.t("allowances.dialog.travel-hotel-meal.start-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.planePrice} id="bus-start" type="text" />
                                    </div>
                                </div>
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-end">{this.props.t("allowances.dialog.travel-hotel-meal.return-price")}</label>
                                        <InputText disabled maxLength={8} pattern="\d*" value={this.props.allowanceTravelMealHotel.planeReturnPrice} id="bus-end" type="text"/>
                                    </div>
                                </div>
                                <div className="col-12 lg:col-6"></div>
                                {
                                    this.props.allowanceTravelMealHotel.planeExpenseDecision !== undefined && this.props.allowanceTravelMealHotel.planeExpenseDecision !== null ?
                                        <div className="col-12 lg:col-12">
                                            <div className="flex flex-column gap-2">
                                                {
                                                    this.props.state === ALLOWANCE_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#22C55E"}}>{this.props.t("allowances.dialog.travel-hotel-meal.approved-expense")} {this.props.allowanceTravelMealHotel.planeExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                                {
                                                    this.props.state === ALLOWANCE_NOT_APPROVED ?
                                                        <label className='mgr-10' style={{color: "#EF4444"}}>{this.props.t("allowances.dialog.travel-hotel-meal.non-approved-expense")} {this.props.allowanceTravelMealHotel.planeExpenseDecision}</label>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        : null
                                }
                            </>
                            : 
                            null
                        }
                        <div className="col-12 mgt-10">
                            <label><b>{this.props.t("allowances.dialog.travel-hotel-meal.observations")}</b></label>
                        </div>
                        <div className="col-12">
                            <InputTextarea disabled style={{width:"100%"}} value={this.props.observations} id="observations" type="text" />
                        </div>
                    </>
                : null
        );
                    }
}

export default withTranslation(AllowanceMealHotelTravelComponent);